
















import { Component, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { SimproJobEntities } from '@/components/add business objects/models/simproJobs';
import AddJobFormEntityList from '@/components/add business objects/add-job/AddJobFormEntityList.vue';
import { AddJobForm } from '@/components/add business objects/add-job/AddJobForm';

@Component({
	components: { AddJobFormEntityList },
	mixins: [validationMixin],
})
export default class AddJobFuelForm extends AddJobForm {
	@Prop()
	public tanks!: SimproJobEntities;

	@Prop({ default: false })
	public editing!: boolean;
}
